import type { GapDetail } from "../types/gap";
import MinistryIcon from "./MinistryIcon";
import { formatMassDateLabel, formatMassTimeParts } from "../lib/mass-time";
import { roleLabel } from "../lib/role-label";

interface Props {
  gap: GapDetail;
  timeZone: string;
}

export default function GapHeader({ gap, timeZone }: Props) {
  const massDate = new Date(gap.massStartsAt);
  const { time, suffix } = formatMassTimeParts(massDate, timeZone);
  const dateLabel = formatMassDateLabel(massDate, timeZone);

  return (
    <header className="gap-header">
      <p className="gap-header__kicker">Sub-request</p>
      <div className="gap-header__row">
        <div className="gap-header__primary">
          <p className="gap-header__date">{dateLabel}</p>
          <h1 className="gap-header__time">
            <span className="gap-header__time-num">{time}</span>
            <span className="gap-header__time-suffix">{suffix}</span>
          </h1>
        </div>
        <div className="gap-header__secondary">
          <p className="gap-header__requester">{gap.requester.name}</p>
          <p className="gap-header__ministry">
            <MinistryIcon ministry={roleLabel(gap.ministry)} />
            <span>{roleLabel(gap.ministry)}</span>
          </p>
        </div>
      </div>
    </header>
  );
}
